import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { AccountService } from 'src/app/services/account.service';
import { BamTransferServiceService } from 'src/app/services/bam-transfer-service.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AccountOptionResponse, AccountResponse } from 'src/app/models/account.model';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { VendorBankService } from 'src/app/services/vendor-bank.service';
import { VendorService } from 'src/app/services/vendor.service';
import { TransferTokenService } from 'src/app/services/transfer-token.service';

@Component({
  selector: 'app-bam-international-transfer',
  templateUrl: './bam-international-transfer.component.html',
  styleUrls: ['./bam-international-transfer.component.scss']
})
export class BamInternationalTransferComponent implements OnInit {
  accounts: AccountResponse[] = [];
  filterAccountsDebit: AccountResponse[] = [];
  filterAccountsCredit: AccountResponse[] = [];
  accountOptions: AccountOptionResponse = null;

  user: any = null;
  company: any = null;

  loading = false;
  confirmModalVisible = false;
  transferPreview: any = null;

  // =========================
  // Request fields
  // =========================
  bankAccountNumberDebit: string = null;
  bankAccountNumberCredit: string = '';
  selectedClientBankAccount: string = '';
  transferType: number = 1; // internacional normalmente terceros
  description: string = '';
  amount: number = null;
  companyId: number = null;

  relationshipCode: number = null;
  relationShipOther: string = '';

  // 1 = Persona natural, 2 = Persona juridica
  type: number = 1;

  countryCode: number = null;
  city: string = '';
  address: string = '';

  firstName: string = '';
  secondName: string = '';
  surname: string = '';
  secondNameSurname: string = '';

  comercialName: string = '';

  bankType: number = null;
  bankCode: string = '';

  commsionCode: number = null;

  egressCode: number = null;
  egressOther: string = '';

  procedenceCode: string = null;
  procedenceOther: string = '';

  client: InputAutocompleteModel = new InputAutocompleteModel("", false, false, "", "loading", "", "", null, []);
  clients = [];
  clientSelected: any = null;
  vendorAccounts: any[] = [];
  timeout: any = null;

  showInputCode = false;
  loadingSendCode = false;
  code2fa = '';

  // =========================
  // Catalogos
  // =========================
  relationshipOptions = [
    { id: 1, name: 'Cliente Comercial' },
    { id: 2, name: 'Proveedor' },
    { id: 3, name: 'Familiar' },
    { id: 4, name: 'Amigo' },
    { id: 5, name: 'Otros' }
  ];

  personTypeOptions = [
    { id: 1, name: 'Persona natural' },
    { id: 2, name: 'Persona jurídica' }
  ];

  // Ajusta estos valores si BAM maneja otro catálogo exacto
  bankTypeOptions = [
    { id: 1, name: 'SWIFT' },
    { id: 2, name: 'ABA' }
  ];

  // Ajusta según catálogo real si tu backend usa valores específicos
  commisionOptions = [
    { id: 1, name: 'OUR - Ordenante paga todas las comisiones' },
    { id: 2, name: 'SHA - Compartidas' },
    { id: 3, name: 'BEN - Beneficiario paga comisiones' }
  ];

  // Ajusta según catálogo real si tu backend usa otros códigos
  egressOptions = [
    { id: 1, name: 'Pago de importaciones' },
    { id: 2, name: 'Pago de servicios' },
    { id: 3, name: 'Ayuda familiar' },
    { id: 4, name: 'Inversión' },
    { id: 5, name: 'Otros' }
  ];

  procedenceOptions = [
    { id: '11', name: 'SALARIO' },
    { id: '12', name: 'AHORROS' },
    { id: '13', name: 'VENTAS DE NEGOCIO' },
    { id: '14', name: 'REMESAS' },
    { id: '15', name: 'MANUTENCION FAMILIAR' },
    { id: '16', name: 'MANUTENCION DE LOS PADRES' },
    { id: '17', name: 'PENSION / JUBILACION' },
    { id: '18', name: 'INDEMNIZACION' },
    { id: '19', name: 'DESEMBOLSO DE PRESTAMO' },
    { id: '21', name: 'DESINVERSION' },
    { id: '22', name: 'HONORARIOS PROFESIONALES' },
    { id: '23', name: 'DIVIDENDOS' },
    { id: '24', name: 'HERENCIA' },
    { id: '25', name: 'DONACIONES' },
    { id: '26', name: 'BECA' },
    { id: '27', name: 'APORTE DE SOCIOS' },
    { id: '28', name: 'OFRENDAS' }
  ];

  countries = [
    { id: 1, name: 'GUATEMALA' },
    { id: 2, name: 'ALEMANIA' },
    { id: 3, name: 'ARGENTINA' },
    { id: 4, name: 'ARUBA' },
    { id: 5, name: 'AUSTRALIA' },
    { id: 6, name: 'AUSTRIA' },
    { id: 7, name: 'BAHAMAS' },
    { id: 8, name: 'BARBADOS' },
    { id: 9, name: 'BELGICA' },
    { id: 10, name: 'BOLIVIA' },
    { id: 11, name: 'BRASIL' },
    { id: 12, name: 'BULGARIA' },
    { id: 13, name: 'CANADA' },
    { id: 14, name: 'CHILE' },
    { id: 15, name: 'CHINA' },
    { id: 16, name: 'COLOMBIA' },
    { id: 17, name: 'COREA' },
    { id: 18, name: 'COSTA RICA' },
    { id: 19, name: 'CROACIA' },
    { id: 20, name: 'CUBA' },
    { id: 21, name: 'DINAMARCA' },
    { id: 22, name: 'ECUADOR' },
    { id: 23, name: 'EGIPTO' },
    { id: 24, name: 'EL SALVADOR' },
    { id: 25, name: 'ESPANA' },
    { id: 26, name: 'ESTADOS UNIDOS' },
    { id: 27, name: 'FILIPINAS' },
    { id: 28, name: 'FINLANDIA' },
    { id: 29, name: 'FRANCIA' },
    { id: 30, name: 'GRAN BRETANA' },
    { id: 31, name: 'GRECIA' },
    { id: 32, name: 'HAITI' },
    { id: 33, name: 'HOLANDA' },
    { id: 34, name: 'HONDURAS' },
    { id: 35, name: 'HONG KONG' },
    { id: 36, name: 'HUNGRIA' },
    { id: 37, name: 'INDIA' },
    { id: 38, name: 'INDONESIA' },
    { id: 39, name: 'IRLANDA' },
    { id: 40, name: 'ISRAEL' },
    { id: 41, name: 'ITALIA' },
    { id: 42, name: 'JAMAICA' },
    { id: 43, name: 'JAPON' },
    { id: 44, name: 'MEXICO' },
    { id: 45, name: 'NICARAGUA' },
    { id: 46, name: 'NORUEGA' },
    { id: 47, name: 'PANAMA' },
    { id: 48, name: 'PARAGUAY' },
    { id: 49, name: 'PERU' },
    { id: 50, name: 'POLONIA' },
    { id: 51, name: 'PORTUGAL' },
    { id: 52, name: 'PUERTO RICO' },
    { id: 53, name: 'REPUBLICA CHECA' },
    { id: 54, name: 'REPUBLICA DOMINICANA' },
    { id: 55, name: 'RUSIA' },
    { id: 56, name: 'SUECIA' },
    { id: 57, name: 'SUIZA' },
    { id: 58, name: 'TAIWAN' },
    { id: 59, name: 'TURQUIA' },
    { id: 60, name: 'URUGUAY' },
    { id: 61, name: 'VENEZUELA' },
    { id: 62, name: 'SENEGAL' },
    { id: 63, name: 'SUDAFRICA' },
    { id: 64, name: 'SINGAPORE' },
    { id: 65, name: 'QATAR' },
    { id: 66, name: 'ARABIA SAUDITA' },
    { id: 67, name: 'CHIPRE' },
    { id: 68, name: 'SIRIA' },
    { id: 69, name: 'JORDANIA' },
    { id: 70, name: 'MALAYSIA' },
    { id: 71, name: 'LIECHTENSTEIN' },
    { id: 72, name: 'LUXEMBURGO' },
    { id: 73, name: 'GROENLANDIA' },
    { id: 74, name: 'TAILANDIA' },
    { id: 75, name: 'BELICE' },
    { id: 76, name: 'ISLAS VIRGENES BRITANICAS' },
    { id: 77, name: 'ISLAS CAIMAN' },
    { id: 78, name: 'CURACAO O ANTILLAS HOLANDESAS' },
    { id: 79, name: 'SAN MARTIN' },
    { id: 80, name: 'MARRUECOS' },
    { id: 81, name: 'PAKISTAN' },
    { id: 89, name: 'ANTIGUA Y BARBUDA' },
    { id: 95, name: 'BAHREIN' },
    { id: 117, name: 'DOMINICA' },
    { id: 118, name: 'EMIRATOS ARABES UNIDOS' },
    { id: 120, name: 'ESLOVAQUIA' },
    { id: 121, name: 'ESLOVENIA' },
    { id: 122, name: 'ESTONIA' },
    { id: 127, name: 'GEORGIA' },
    { id: 130, name: 'GRANADA' },
    { id: 161, name: 'KENIA' },
    { id: 164, name: 'KUWAIT' },
    { id: 167, name: 'LETONIA' },
    { id: 171, name: 'LITUANIA' },
    { id: 177, name: 'MALTA' },
    { id: 179, name: 'MAURICIO' },
    { id: 184, name: 'MONACO' },
    { id: 187, name: 'MONTSERRAT' },
    { id: 193, name: 'NIGERIA' },
    { id: 197, name: 'NUEVA ZELANDA' },
    { id: 207, name: 'RUMANIA' },
    { id: 216, name: 'SANTA LUCIA' },
    { id: 219, name: 'SEYCHELLES' },
    { id: 222, name: 'SRI LANKA' },
    { id: 236, name: 'TRINIDAD Y TOBAGO' },
    { id: 244, name: 'VIETNAM' },
    { id: 250, name: 'MACEDONIA' },
    { id: 252, name: 'SANTA LUCIA' },
    { id: 253, name: 'LATVIA' }
  ];

  constructor(
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private accountService: AccountService,
    private bamTransferService: BamTransferServiceService,
    private vendorService: VendorService,
    private vendorBankService: VendorBankService,
    private transferTokenService: TransferTokenService
  ) {
    this.user = this.authService.getUser();
    this.company = JSON.parse(this.authService.getCurrentCompany());
    this.companyId = this.company?.companyId ?? null;
  }

  ngOnInit(): void {
    this.getBanksOwn();
    this.getAccountOptions();
    this.getInitVendors();
  }

  getBanksOwn(): void {
    this.accountService.getAccounts().subscribe({
      next: (response: ResponseObject) => {
        this.accounts = response.data || [];
        console.log(this.accounts)
        this.filterAccountsDebit = this.accounts.filter(
          account => account.bank == 4 && account.international === false
        );

        this.filterAccountsCredit = this.accounts.filter(
          account => account.international === true
        );
      },
      error: (_error: HttpErrorResponse) => {
        this.toastService.error('Error al obtener las cuentas bancarias');
      }
    });
  }

  getAccountOptions(): void {
    this.accountService.getAccountOptions().subscribe({
      next: (response: ResponseObject) => {
        this.accountOptions = response.data as AccountOptionResponse;
      },
      error: (_error: HttpErrorResponse) => {
        this.toastService.error('Error al obtener catálogos de cuentas');
      }
    });
  }

  getBankName(idBank: number): string {
    if (!this.accountOptions || !this.accountOptions.erpBanks) return '';
    const bank = this.accountOptions.erpBanks.find(b => b.id === idBank);
    return bank ? bank.name : 'Banco desconocido';
  }

  getCountryName(code: number): string {
    const country = this.countries.find(c => c.id === code);
    return country ? country.name : '';
  }

  getRelationshipName(id: number): string {
    const item = this.relationshipOptions.find(x => x.id === id);
    return item ? item.name : '';
  }

  getPersonTypeName(id: number): string {
    const item = this.personTypeOptions.find(x => x.id === id);
    return item ? item.name : '';
  }

  getBankTypeName(id: number): string {
    const item = this.bankTypeOptions.find(x => x.id === id);
    return item ? item.name : '';
  }

  getCommissionName(id: number): string {
    const item = this.commisionOptions.find(x => x.id === id);
    return item ? item.name : '';
  }

  getEgressName(id: number): string {
    const item = this.egressOptions.find(x => x.id === id);
    return item ? item.name : '';
  }

  getProcedenceName(id: string): string {
    const item = this.procedenceOptions.find(x => x.id === id);
    return item ? item.name : '';
  }

  isNaturalPerson(): boolean {
    return this.type === 1;
  }

  isLegalPerson(): boolean {
    return this.type === 2;
  }

  clearPersonFieldsByType(): void {
    if (this.isNaturalPerson()) {
      this.comercialName = '';
    } else {
      this.firstName = '';
      this.secondName = '';
      this.surname = '';
      this.secondNameSurname = '';
    }
  }

  validateForm(): boolean {
    if (!this.bankAccountNumberDebit) {
      this.toastService.error('Debes seleccionar la cuenta a debitar');
      return false;
    }

    if (this.transferType === 0 && !this.bankAccountNumberCredit) {
      this.toastService.error('Debes seleccionar la cuenta destino');
      return false;
    }

    if (this.transferType === 1 && !this.clientSelected) {
      this.toastService.error('Debes seleccionar un cliente');
      return false;
    }

    if (this.transferType === 1 && !this.selectedClientBankAccount) {
      this.toastService.error('Debes seleccionar la cuenta bancaria del cliente');
      return false;
    }

    if (this.transferType === 0 && this.bankAccountNumberDebit === this.bankAccountNumberCredit) {
      this.toastService.error('La cuenta de débito no puede ser igual a la cuenta destino');
      return false;
    }

    if (this.bankAccountNumberDebit === this.bankAccountNumberCredit) {
      this.toastService.error('La cuenta de débito no puede ser igual a la cuenta destino');
      return false;
    }

    if (!this.amount || this.amount <= 0) {
      this.toastService.error('Debes ingresar un monto válido');
      return false;
    }

    if (!this.description || !this.description.trim()) {
      this.toastService.error('Debes ingresar una descripción');
      return false;
    }

    if (!this.relationshipCode) {
      this.toastService.error('Debes seleccionar la relación con el beneficiario');
      return false;
    }

    if (this.relationshipCode === 5 && !this.relationShipOther.trim()) {
      this.toastService.error('Debes indicar el detalle de la relación');
      return false;
    }

    if (this.type === null || this.type === undefined) {
      this.toastService.error('Debes seleccionar el tipo de beneficiario');
      return false;
    }

    if (!this.countryCode) {
      this.toastService.error('Debes seleccionar el país destino');
      return false;
    }

    if (!this.city.trim()) {
      this.toastService.error('Debes ingresar la ciudad');
      return false;
    }

    if (!this.address.trim()) {
      this.toastService.error('Debes ingresar la dirección');
      return false;
    }

    if (this.isNaturalPerson()) {
      if (!this.firstName.trim()) {
        this.toastService.error('Debes ingresar el primer nombre del beneficiario');
        return false;
      }

      // if (!this.secondName.trim()) {
      //   this.toastService.error('Debes ingresar el segundo nombre del beneficiario');
      //   return false;
      // }

      if (!this.surname.trim()) {
        this.toastService.error('Debes ingresar el primer apellido del beneficiario');
        return false;
      }

      // if (!this.secondNameSurname.trim()) {
      //   this.toastService.error('Debes ingresar el segundo apellido del beneficiario');
      //   return false;
      // }
    }

    if (this.isLegalPerson() && !this.comercialName.trim()) {
      this.toastService.error('Debes ingresar el nombre comercial');
      return false;
    }

    if (!this.bankType) {
      this.toastService.error('Debes seleccionar el tipo de banco');
      return false;
    }

    if (!this.bankCode.trim()) {
      this.toastService.error('Debes ingresar el código del banco');
      return false;
    }

    if (!this.commsionCode) {
      this.toastService.error('Debes seleccionar el tipo de comisión');
      return false;
    }

    if (!this.egressCode) {
      this.toastService.error('Debes seleccionar el motivo de egreso');
      return false;
    }

    if (this.egressCode === 5 && !this.egressOther.trim()) {
      this.toastService.error('Debes indicar el detalle del egreso');
      return false;
    }

    if (!this.procedenceCode) {
      this.toastService.error('Debes seleccionar la procedencia de fondos');
      return false;
    }

    const code = this.bankCode.trim();
    const length = code.length;

    if (this.bankType === 1) {
      if (length < 8 || length > 11) {
        this.toastService.error('El código del banco debe tener entre 8 y 11 caracteres');
        return false;
      }
    }

    if (this.bankType === 2) {
      if (length !== 9) {
        this.toastService.error('El código del banco debe tener exactamente 9 caracteres');
        return false;
      }
    }

    return true;
  }

  buildRequest(): any {
    return {
      bankAccountNumberDebit: this.bankAccountNumberDebit,
      bankAccountNumberCredit: this.transferType === 0
        ? this.bankAccountNumberCredit
        : this.selectedClientBankAccount,
      transferType: this.transferType,
      description: this.normalizeText(this.description),
      amount: this.amount,
      company: this.companyId,

      relationshipCode: this.relationshipCode,
      relationShipOther: this.relationshipCode === 5 ? this.normalizeText(this.relationShipOther) : '',

      type: this.type,
      countryCode: this.countryCode,
      city: this.normalizeText(this.city),
      address: this.normalizeText(this.address),

      firstName: this.isNaturalPerson() ? this.normalizeText(this.firstName) : '',
      secondName: this.isNaturalPerson() ? this.normalizeText(this.secondName) : '',
      surname: this.isNaturalPerson() ? this.normalizeText(this.surname) : '',
      secondNameSurname: this.isNaturalPerson() ? this.normalizeText(this.secondNameSurname) : '',
      comercialName: this.isLegalPerson() ? this.normalizeText(this.comercialName) : '',

      bankType: this.bankType,
      bankCode: this.bankCode.trim(),
      commsionCode: this.commsionCode,

      egressCode: this.egressCode,
      egressOther: this.egressCode === 5 ? this.normalizeText(this.egressOther) : '',

      procedenceCode: this.procedenceCode,
      procedenceOther: this.normalizeText(this.procedenceOther),
      token: this.code2fa
    };
  }

  openConfirmModal(): void {
    this.clearPersonFieldsByType();

    if (!this.validateForm()) {
      return;
    }

    const debitAccount = this.accounts.find(
      acc => String(acc.accountNumber) === String(this.bankAccountNumberDebit)
    );

    this.transferPreview = {
      amount: this.amount,
      description: this.description,
      debitAccount,
      bankAccountNumberCredit: this.transferType === 0
        ? this.bankAccountNumberCredit
        : this.selectedClientBankAccount,
      clientSelected: this.clientSelected,
      relationshipName: this.getRelationshipName(this.relationshipCode),
      personTypeName: this.getPersonTypeName(this.type),
      countryName: this.getCountryName(this.countryCode),
      beneficiaryName: this.isNaturalPerson()
        ? `${this.firstName || ''} ${this.secondName || ''} ${this.surname || ''} ${this.secondNameSurname || ''}`.trim()
        : this.comercialName,
      bankTypeName: this.getBankTypeName(this.bankType),
      commissionName: this.getCommissionName(this.commsionCode),
      egressName: this.getEgressName(this.egressCode),
      procedenceName: this.getProcedenceName(this.procedenceCode)
    };

    this.confirmModalVisible = true;
  }

  onConfirmTransfer(): void {
   if (!this.code2fa) {
      this.toastService.error('Debes ingresar el código de seguridad');
      return;
    }

    this.confirmModalVisible = false;
    this.sendRequest();
  }

  onCancelTransfer(): void {
    this.confirmModalVisible = false;
    this.loadingSendCode = false;
    this.showInputCode = false;
    this.code2fa = '';
  }

  sendRequest(): void {
    if (!this.code2fa) {
      this.toastService.error('Debes ingresar el código de seguridad');
      return;
    }

    const request = this.buildRequest();

    this.loading = true;

    this.bamTransferService.sendInternationalTransfer(request).subscribe({
      next: (_response: any) => {
        if (_response.data.code != "OPERATION_SUCCESSFUL") {
          this.toastService.error(_response.data.message, _response.data.code);
          return;
        }
        this.toastService.success('Transferencia internacional realizada correctamente');
        this.resetForm();
        this.loading = false;
      },
      error: (err: any) => {
        console.error('Error al generar la transferencia internacional', err);
        if (err.data.description) {
          this.toastService.error(err.data.description + ' [Error al generar la transferencia internacional, revisa el historial para más detalle]' );
        } else {
          this.toastService.error('Error al generar la transferencia internacional, revisa el historial para más detalle');
        }
        this.loading = false;
      }
    });
  }

  resetForm(): void {
    this.bankAccountNumberDebit = null;
    this.bankAccountNumberCredit = '';
    this.transferType = 1;
    this.description = '';
    this.amount = null;

    this.relationshipCode = null;
    this.relationShipOther = '';

    this.type = 1;
    this.countryCode = null;
    this.city = '';
    this.address = '';

    this.firstName = '';
    this.secondName = '';
    this.surname = '';
    this.secondNameSurname = '';
    this.comercialName = '';

    this.bankType = null;
    this.bankCode = '';

    this.commsionCode = null;

    this.egressCode = null;
    this.egressOther = '';

    this.procedenceCode = null;
    this.procedenceOther = '';

    this.transferPreview = null;
    this.confirmModalVisible = false;

    this.client = new InputAutocompleteModel("", false, false, "", "loading", "", "", null, []);
    this.clientSelected = null;
    this.vendorAccounts = [];
    this.selectedClientBankAccount = "";

    this.loadingSendCode = false;
    this.showInputCode = false;
    this.code2fa = '';
  }

  sendRequestCode() {
    this.loadingSendCode = true;
    
    this.transferTokenService.createTokenTransfer().subscribe({
      next: (_response: ResponseObject) => {
        this.showInputCode = true;
        this.loadingSendCode = false;
      },
      error: (_error: HttpErrorResponse) => {
        this.toastService.error('Error al solicitar token');
        this.loadingSendCode = false;
      }
    });
  }

  async pastClipboard() {
    try {
      this.code2fa = await navigator.clipboard.readText();
    } catch (error) {
      console.error('No se pudo leer el portapapeles', error);
      this.toastService.error('No se pudo leer el portapapeles');
    }
  }

  normalizeText(value: string): string {
    if (!value) return '';
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[ñÑ]/g, 'N')
      .replace(/[^a-zA-Z0-9\s.,\-/#]/g, '')
      .trim();
  }

  getInitVendors(): void {
    this.vendorService.getVendors().subscribe({
      next: (response: ResponseObject) => {
        const clientsData = response.data || [];
        this.clients = clientsData;
        this.client.filterElements = clientsData;
        this.client.class = 'fa-list';
      },
      error: (error) => {
        console.error('Error al comunicarse con el servidor', error);
        this.toastService.error('Error al obtener clientes');
      }
    });
  }

  writeClient(): void {
    clearTimeout(this.timeout);
    this.client.class = 'typing';

    this.timeout = setTimeout(() => {
      this.client.class = 'loading';
      this.vendorService.getProvidesByClue(this.client.value).subscribe({
        next: (response: ResponseObject) => {
          this.client.filterElements = response.data || [];
          if (this.client.filterElements.length === 0) {
            this.client.class = 'fa-xmark';
            this.client.required = true;
          } else {
            this.client.class = 'fa-filter';
          }
        },
        error: (_error: any) => {
          this.client.required = true;
          this.client.class = 'fa-xmark';
          this.toastService.error('Error al obtener los datos del cliente ' + this.client.value);
        }
      });
    }, 500);
  }

  selectClient(client: any): void {
    this.clientSelected = client;
    this.selectedClientBankAccount = null;
    this.getBanksByClient(client.id);
  }

  getBanksByClient(idVendor: number): void {
    this.vendorBankService.getVendorBanksByVendorId(idVendor).subscribe({
      next: (response: ResponseObject) => {
        const accountsVendor = response.data || [];

        this.vendorAccounts =  accountsVendor.filter(
          account => account.international === true
        );
      },
      error: (error) => {
        console.error('Error al comunicarse con el servidor', error);
        this.toastService.error('Error al obtener cuentas bancarias del cliente');
      }
    });
  }
}